import { gql } from "@apollo/client";

export const getContractFromBi = gql`
query NE_GetContractFromBi($filter: FilterFindManybuyer_purchases_historyInput!) {
  contract: bi_buyer_purchases_historyMany(filter: $filter) {
    contract
    lineitems
    who
    photos
    statements
    lineitems
    organisations
    photos
    plots
    people
  }
}
`
// Single market day + organisation; replaces the palmoil completed-contract
// query on the purchases "Current" tab, and drives the Today Delivery gate view.
//
// The gate view resolves a delivery position by falling back down three rungs:
//   1. the truck photo -- `truck_photo` below is its `gs://` URI, and its GPS
//      comes off the storage object's `photo_location` custom metadata.
//      Note the weight receipt carries no position, so it cannot stand in.
//   2. the Unilever plot -- needs `unilever_land_plot { position { coordinates } }`
//      or equivalent; today it only exists on the BI views.
//   3. the supplier -- `supplier.organisation.position`, selected below but null
//      on every contract so far. Its `location` (the region picked at
//      registration) is always set.
// buildContractListForMarketDay already reads all three.
export const GetContractsForMarketDay = gql`
query NE_ContractListForMarketDay($filter: ne_contract_list_input!) {
  ne_contract_list(filter: $filter) {
    contracts {
      contract_id
      buyer_statement_id
      contract_type
      status
      market_day
      quantity_loaded
      dropoff_date
      price_per_kg
      truck_photo
      supplier {
        organisation {
          id
          name
          position { coordinates }
          location {
            village
            subdistrict
            district
            province
          }
        }
      }
      dropoff {
        weight_receipt_uri
      }
    }
  }
}
`

// The dialog is opened for what the UI calls a NAC, and the codebase has two
// definitions of that: contract_type "NAC" (ContractList) and status
// "AUTOCOMPLETED" (FruitTraceability). The first is served by
// nac_contract_detail, the second by nam_contract_detail, and both return null
// rather than erroring when the statement is not theirs -- so ask both and take
// whichever answers. Only the statement is needed; the rest of either contract
// is left out on purpose.
export const GetAdjustmentStatement = gql`
  query NE_GetAdjustmentStatement($statementId: Int!) {
    nac: nac_contract_detail(statement_id: $statementId) {
      contract_id
      statement { ...AdjustmentStatement }
    }
    nam: nam_contract_detail(filter: { statement_id: $statementId }) {
      contract_id
      statement { ...AdjustmentStatement }
    }
  }

  fragment AdjustmentStatement on statement {
    id
    total_amount
    line_items {
      sku
      title
      quantity
      price_per_unit
      total
    }
  }
`
